import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  fetchDistrictByRegencyId,
  fetchRegencyByProvinceId,
  fetchSubDistrictByDistrictId,
  getListRegionalAll
} from "../../../../../redux/actions/MasterDataAction.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle
} from "../../../../../_metronic/_partials/controls/index.js"
import { DetailText, RowText } from "../../../../../component/index.jsx"
import { BaseMapSelector } from "../../../../../component/atoms/MapSelector/BaseMapSelector.jsx"
import { Marker } from "@react-google-maps/api"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { toStringDate } from "../../../../helpers/DateHelper.js"
import { useTranslation } from "react-i18next"
import { GENDER_REQUEST_ENUM } from "../../../../../constants/StringConstant.js"

export const ReviewIndividual = ({ formData, editStep }) => {
  const dispatch = useDispatch()
  const { Mitra, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()

  const [bankName, setBankName] = useState("")
  const [proviceName, setProvinceName] = useState("")
  const [regencyName, setRegencyName] = useState("")
  const [districtName, setDistrictName] = useState("")
  const [subDistrictName, setSubDistrictName] = useState("")
  const [mitraType, setMitraType] = useState("")

  const regionalList = MasterData?.listRegionalAll ?? []
  const regional = regionalList?.find((e) => e?.id === formData?.regionalId)?.name ?? "-"
  const subRegionalList = MasterData?.listSubRegionalByRole ?? []
  const subRegional = subRegionalList?.find((e) => e?.id === formData?.sub_regional_id)?.name ?? "-"

  useEffect(() => {
    dispatch(getListRegionalAll())
  }, [])

  useEffect(() => {
    if (MasterData.bankList.length !== 0) {
      setBankName(MasterData.bankList.find((value) => value.id === formData?.bank_id))
    }
  }, [MasterData.bankList])

  useEffect(() => {
    if (MasterData.provinceList.length !== 0) {
      setProvinceName(MasterData.provinceList.find((value) => value.id === formData?.mitraProvince))
      dispatch(fetchRegencyByProvinceId(formData?.mitraProvince))
    }
  }, [MasterData.provinceList])

  useEffect(() => {
    if (MasterData.regencyList.length !== 0) {
      setRegencyName(MasterData.regencyList.find((value) => value.id === formData?.mitraRegency))
      dispatch(fetchDistrictByRegencyId(formData?.mitraRegency))
    }
  }, [MasterData.regencyList])

  useEffect(() => {
    if (MasterData.districtList.length !== 0) {
      setDistrictName(MasterData.districtList.find((value) => value.id === formData?.mitraDistrict))
      dispatch(fetchSubDistrictByDistrictId(formData?.mitraDistrict))
    }
  }, [MasterData.districtList])

  useEffect(() => {
    if (MasterData.subDistrictList.length !== 0) {
      setSubDistrictName(
        MasterData.subDistrictList.find((value) => value.id === formData?.mitraSubDistrict)
      )
    }
  }, [MasterData.subDistrictList])

  useEffect(() => {
    if (Mitra.type) {
      setMitraType(Mitra.type.filter((item) => item.mitra_type_enum === formData.mitra_type))
    }
  }, [Mitra])

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <Card className="card-custom card-shadowless">
              <CardBody>
                <RowModule>
                  <CardHeaderTitle className={"py-10"}>
                    {"ReviewIndividual data MITRA".toUpperCase()}
                  </CardHeaderTitle>
                </RowModule>
              </CardBody>
              <div className={"d-flex justify-content-between align-items-center px-7"}>
                <h4>{t("label_mitra_data").toUpperCase()}</h4>
                <a
                  className={"link"}
                  onClick={() => {
                    editStep(0)
                  }}>
                  EDIT
                </a>
              </div>
              <CardBody>
                <div className="mb-10">
                  <DetailText title={t("label_photo_profile")} />
                  <DetailText type="image-dashed" value={formData?.mitra_pic_url} />
                </div>
                <RowModule customColumnCss={"col-md-6"}>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_mitra_type")} value={mitraType[0]?.title} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_telp_number")} value={formData?.phone} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_regional")} value={regional} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_sub_regional")} value={subRegional} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_date_of_birth")} value={toStringDate(formData?.dob)} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={t("label_mitra_name")} value={formData?.name} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText
                      label={t("label_gender")}
                      value={
                        formData?.gender === GENDER_REQUEST_ENUM.MALE
                          ? t("label_men")
                          : formData?.gender === GENDER_REQUEST_ENUM.FEMALE
                          ? t("label_woman")
                          : "-"
                      }
                    />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText label={"Email"} value={formData?.email} />
                  </RowModule>
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <RowText
                      label={t("label_mitra_domicile_address")}
                      value={
                        formData?.mitraAddress +
                        ", " +
                        subDistrictName.name +
                        ", " +
                        districtName.name +
                        ", " +
                        regencyName.name +
                        ", " +
                        proviceName.name
                      }
                    />
                  </RowModule>
                </RowModule>
                {/* Map pin location preview */}
                {formData?.latitude && formData?.longitude && (
                  <RowModule customColumnCss={"col-md-12 mb-2"}>
                    <div>
                      <BaseMapSelector
                        className={"rounded-lg mb-2"}
                        id={"review-individual-map"}
                        latitude={formData.latitude}
                        longitude={formData.longitude}
                        isSelector={false}
                        editable={false}
                        customMarkers={() => (
                          <Marker
                            position={{
                              lat: parseFloat(formData.latitude),
                              lng: parseFloat(formData.longitude)
                            }}
                            icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_MITRA)}
                            draggable={false}
                          />
                        )}
                        customContainerStyle={{ height: "250px" }}
                        options={{ zoomControl: false }}
                        zoom={15}
                      />
                    </div>
                  </RowModule>
                )}
                <CardHeader />
              </CardBody>
            </Card>
          </RowModule>
          <RowModule>
            <Card className="card-custom card-shadowless">
              <div className={"d-flex justify-content-between align-items-center px-7"}>
                <h4>{t("label_mitra_document")}</h4>
                <a
                  className={"link"}
                  onClick={() => {
                    editStep(1)
                  }}>
                  EDIT
                </a>
              </div>
              <CardBody>
                <RowText label={t("label_name_as_per_id")} value={formData?.name} />
                <RowText label={t("label_ktp_number")} value={formData?.ktp_no} />
                <DetailText title={t("label_ktp_picture")} />
                <DetailText type="image-dashed" value={formData?.ktp_pic_url} />
                <DetailText title={t("label_selfie_with_ktp")} />
                <DetailText type="image-dashed" value={formData?.ktp_selfie_pic_url} />
                <DetailText title={t("label_kk_picture")} />
                <DetailText type="image-dashed" value={formData?.business_document_pic_url} />
                <RowText label={t("label_npwp_number")} value={formData?.npwp_no} />
                <DetailText title={t("label_npwp_picture")} />
                <DetailText type="image-dashed" value={formData?.other_image} />
                <CardHeader />
              </CardBody>
            </Card>
          </RowModule>
          <RowModule>
            <Card className="card-custom card-shadowless mt-8">
              <div className={"d-flex justify-content-between align-items-center px-7"}>
                <h4>{t("label_bank_account").toUpperCase()}</h4>
                <a
                  className={"link"}
                  onClick={() => {
                    editStep(2)
                  }}>
                  EDIT
                </a>
              </div>
              <CardBody>
                <RowText label={t("label_bank_name")} value={bankName?.name} />
                <RowText label={t("label_account_number")} value={formData?.bank_account_number} />
                <RowText label={t("label_account_name")} value={formData?.bank_account_name} />
                <CardHeader />
              </CardBody>
            </Card>
          </RowModule>
        </CardBody>
      </Card>
    </>
  )
}
